export const reactNativeWindow = window;
